module.exports = __webpack_public_path__ + "static/img/yx-logo.ecde9962.png";